export default {
  "정기안전보건" : `■ 산업안전 및 산업재해 예방에 관한 사항
  (화재·폭발 사고 발생 시 대피에 관한 사항을 포함한다)

■ 산업보건 및 건강장해 예방에 관한 사항
  (폭염·한파작업으로 인한 건강장해 발생 시 응급조치에 관한 사항을 포함한다)

■ 위험성평가에 관한 사항

■ 건강증진 및 질병 예방에 관한 사항

■ 유해·위험 작업환경 관리에 관한 사항

■ 산업안전보건법령 및 산업재해보상보험 제도에 관한 사항

■ 직무스트레스 예방 및 관리에 관한 사항

■ 직장 내 괴롭힘, 고객의 폭언 등으로 인한 건강장해 예방 및 관리에 관한 사항`,


  "관리감독자교육": `■ 산업안전 및 산업재해 예방에 관한 사항
  (화재·폭발 사고 발생 시 대피에 관한 사항을 포함한다)

■ 산업보건 및 건강장해 예방에 관한 사항

■ 위험성평가에 관한 사항

■ 산업안전보건법령 및 산업재해보상보험 제도에 관한 사항

■ 직무스트레스 예방 및 관리에 관한 사항

■ 직장 내 괴롭힘, 고객의 폭언 등으로 인한 건강장해 예방 및 관리에 관한 사항

■ 기계·기구의 위험성과 작업의 순서 및 동선에 관한 사항

■ 작업 개시 전 점검에 관한 사항

■ 정리정돈 및 청소에 관한 사항

■ 사고 발생 시 긴급조치에 관한 사항

■ 물질안전보건자료에 관한 사항`,


  "환경교육직무보수교육": ``,


  "외부업체교육": ``,


  "특별안전보건": ``,


  "신입사원교육": `■ 산업안전 및 산업재해 예방에 관한 사항
  (화재·폭발 사고 발생 시 대피에 관한 사항을 포함한다)

■ 산업보건 및 건강장해 예방에 관한 사항

■ 위험성평가에 관한 사항

■ 산업안전보건법령 및 산업재해보상보험 제도에 관한 사항

■ 직무스트레스 예방 및 관리에 관한 사항

■ 직장 내 괴롭힘, 고객의 폭언 등으로 인한 건강장해 예방 및 관리에 관한 사항

■ 기계·기구의 위험성과 작업의 순서 및 동선에 관한 사항

■ 작업 개시 전 점검에 관한 사항

■ 정리정돈 및 청소에 관한 사항

■ 사고 발생 시 긴급조치에 관한 사항

■ 물질안전보건자료에 관한 사항`,


  "직무전환교육": `■ 산업안전 및 산업재해 예방에 관한 사항
  (화재·폭발 사고 발생 시 대피에 관한 사항을 포함한다)

■ 산업보건 및 건강장해 예방에 관한 사항

■ 위험성평가에 관한 사항

■ 산업안전보건법령 및 산업재해보상보험 제도에 관한 사항

■ 직무스트레스 예방 및 관리에 관한 사항

■ 직장 내 괴롭힘, 고객의 폭언 등으로 인한 건강장해 예방 및 관리에 관한 사항

■ 기계·기구의 위험성과 작업의 순서 및 동선에 관한 사항

■ 작업 개시 전 점검에 관한 사항

■ 정리정돈 및 청소에 관한 사항

■ 사고 발생 시 긴급조치에 관한 사항

■ 물질안전보건자료에 관한 사항`,


  "TQM교육": ``,


  "소방교육": ``,
}
